import React from 'react';



const TypingIndicator = () => {
  return (
    <div className="message assistant">
      <div className="message-content">
        <div className="message-header">
          <div className="message-icon">4Q</div>
          <span>Java Dev Assistant</span>
        </div>
        <div className="typing-indicator">
          <span className="typing-dot"></span>
          <span className="typing-dot"></span>
          <span className="typing-dot"></span>
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;
